<ap-drawer
  #drawer
  [(visible)]="isVisible"
  placement="right"
  [drawerTitle]="title"
  [closable]="closable"
  (onClose)="closeHandler($event)"
  [mask]="mask">
  <ng-container gstarContainer />
  <ng-template ngTemplate="footer">
    @if (hideButton) {
      <div class="d-flex gap-3">
        @if (secondaryLabelButton) {
          <ap-button
            btnType="secondary"
            (onClick)="secondaryHandler()"
            [label]="secondaryLabelButton"
            [icon]="secondaryIconButton" />
        }
        <ap-button
          btnType="primary"
          (onClick)="primaryHandler()"
          [label]="primaryLabelButton"
          [disabled]="primaryButtonDisabled"
          [icon]="primaryIconButton" />
      </div>
    }
  </ng-template>
</ap-drawer>
